'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosVideocamOutline = function IoIosVideocamOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.6 10c1.5 0 2.6 1.1 2.6 2.6v14.7c0 1.5-1.1 2.7-2.6 2.7h-17.3c-1.5 0-2.8-1.2-2.8-2.7v-14.7c0-1.5 1.3-2.6 2.8-2.6h17.3z m1.2 17.3v-14.7c0-0.7-0.6-1.3-1.3-1.3h-17.3c-0.7 0-1.4 0.6-1.4 1.3v14.7c0 0.7 0.8 1.4 1.5 1.4h17.3c0.7 0 1.2-0.7 1.2-1.4z m3.7-10.7l7.7-4.1v15l-7.7-4.1v-6.8z m6.3-1.8l-5 2.6v5.2l5 2.6v-10.4z' })
        )
    );
};

exports.default = IoIosVideocamOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-videocam-outline.js
// module id = 2316
// module chunks = 0